var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitterX = function SvgIconTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.226 0h2.76l-6.06 6.9 7.08 9.36H12.45L8.1 10.572 3.12 16.26H.36l6.42-7.38L0 0h5.694l3.93 5.196L14.226 0Zm-.966 14.64h1.53L4.89 1.56H3.246L13.26 14.64Z",
    fill: "currentColor"
  })));
};
export { SvgIconTwitterX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjIyNiAwSDE2Ljk4NkwxMC45MjYgNi45TDE4LjAwNiAxNi4yNkgxMi40NUw4LjEgMTAuNTcyTDMuMTIgMTYuMjZIMC4zNkw2Ljc4IDguODhMMCAwSDUuNjk0TDkuNjI0IDUuMTk2TDE0LjIyNiAwWk0xMy4yNiAxNC42NEgxNC43OUw0Ljg5IDEuNTZIMy4yNDZMMTMuMjYgMTQuNjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";